import { render } from "./HeroiconsOutlineQrcode.vue?vue&type=template&id=1fa0c7c0"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__